import { Dashboard, RequestsForMe } from '@/components';

export const RequestsForMePage = () => (
  <Dashboard isSearch openLogIn>
    <RequestsForMe />
  </Dashboard>
);
